import { InjectionToken } from '@angular/core';

/** Injection token used to provide the parent chip to action directives. Based on Angular Material MAT_CHIP pattern. */
export const MAT_CHIP = new InjectionToken<{
  _handlePrimaryActionInteraction(): void;
  remove(): void;
  disabled: boolean;
}>('MAT_CHIP');

/** Configuration for chip input separator keys. Supports both simple keycodes and modifier key combinations. */
export type SeparatorKey = {
  keyCode: number;
  modifiers?: readonly ('shiftKey' | 'ctrlKey' | 'altKey' | 'metaKey')[];
};
